@let texts = resourcesService.languageFile.value();
@let t = theme();
<div class="theme">
  <div class="theme-image"><img src="{{t.imageURL.url}}" [alt]="t.imageURL.alt"></div>
  <div class="theme-column">
    <h2 class="theme-name">{{ t.name }}</h2>
    <p-button class="theme-button"
              (onClick)="store.startGame(t.id)"
              [disabled]="!!store.error()">
      <span>{{ texts.start }}</span>
      <span><i class="pi pi-arrow-right"></i> </span>
    </p-button>
  </div>
</div>
